export const getSafeCircularReplacer = () => {
  const ancestors: unknown[] = [];
  return function (this: unknown, _key: string, value: unknown) {
    if (typeof value !== 'object' || value === null) {
      return value;
    }
    while (ancestors.length > 0 && ancestors[ancestors.length - 1] !== this) {
      ancestors.pop();
    }
    if (ancestors.includes(value)) {
      return;
    }
    ancestors.push(value);
    return value;
  };
};
